<template>
<!-- {{polypath}} -->
<!-- {{polyline}} -->
<!-- {{center1}} -->
    <GmapMap
  :center="center1"
  :zoom="12"
  map-type-id="terrain"
  style="width: 800px; height: 600px"
>
<GmapMarker :position="center1">
</GmapMarker>
  <!-- <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position"
  /> -->
</GmapMap>
    
</template>
<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA62nfiBf_7XngEJxzZxltpRMbJjd2f7Fg',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})
export default {
    props: ['center1','centerstart','polyline','polypath'],
    data() {
        return {
            polyline_show:true,
            markers:[]
            // polypath:{}
            
        }
    },
    components:{
       // GoogleMap, Marker,Polyline

    },
    watch:{
        polypath:function(val){
            // alert("here");
            
            this.polyline.path=val.path;
            // this.$ref.mapRef.show();
            // this.refs.mapRef.update();
            // this.polypath=val;
            // console.log(val.path);
            
            
        }
    
    // mathods()
    // {
    //     //   const map = new google.maps.Map(document.getElementById("map"), {
    //     //     zoom: 8,
    //     //     center: { lat: 35.717, lng: 139.731 },
    //     // });

    // },
    // mounted(){
    //     // this.polypath = {
    //     //         path: this.polyline,
    //     //         geodesic: true,
    //     //         strokeColor: '#FF0000',
    //     //         strokeOpacity: 1.0,
    //     //         strokeWeight: 2,
    //     //         }
            
    }
}
</script>